// src/state/customers/changeData/types.ts
var CustomersErrorsId = /* @__PURE__ */ ((CustomersErrorsId2) => {
  CustomersErrorsId2["GENERIC_ERROR"] = "genericError";
  return CustomersErrorsId2;
})(CustomersErrorsId || {});
var CustomersSectionId = /* @__PURE__ */ ((CustomersSectionId2) => {
  CustomersSectionId2["ALL"] = "all";
  CustomersSectionId2["BASIC"] = "basic";
  CustomersSectionId2["ADDRESS"] = "address";
  CustomersSectionId2["CARD"] = "card";
  CustomersSectionId2["ORDERS"] = "orders";
  return CustomersSectionId2;
})(CustomersSectionId || {});
var SET_CUSTOMERS_CHANGE_DATA = "SET_CUSTOMERS_CHANGE_DATA";
var SET_CUSTOMERS_DIFF_OBJECT = "SET_CUSTOMERS_DIFF_OBJECT";
var SET_CUSTOMERS_CHANGE_DATA_VALUES = "SET_CUSTOMERS_CHANGE_DATA_VALUES";
var RESET_CUSTOMERS_CHANGE_DATA = "RESET_CUSTOMERS_CHANGE_DATA";
var UPDATE_CUSTOMERS_CHANGE_DATA_VALUES = "UPDATE_CUSTOMERS_CHANGE_DATA_VALUES";
var SET_SELECTED_CUSTOMERS_LOCATIONS = "SET_SELECTED_CUSTOMERS_LOCATIONS";
var RESET_CUSTOMERS_CHANGES = "RESET_CUSTOMERS_CHANGES";
var SET_CUSTOMERS_ERRORS = "SET_CUSTOMERS_ERRORS";
var UPDATE_CUSTOMERS_ERRORS = "UPDATE_CUSTOMERS_ERRORS";
var CLEAR_CUSTOMERS_ERROR = "CLEAR_CUSTOMERS_ERROR";

export { CLEAR_CUSTOMERS_ERROR, CustomersErrorsId, CustomersSectionId, RESET_CUSTOMERS_CHANGES, RESET_CUSTOMERS_CHANGE_DATA, SET_CUSTOMERS_CHANGE_DATA, SET_CUSTOMERS_CHANGE_DATA_VALUES, SET_CUSTOMERS_DIFF_OBJECT, SET_CUSTOMERS_ERRORS, SET_SELECTED_CUSTOMERS_LOCATIONS, UPDATE_CUSTOMERS_CHANGE_DATA_VALUES, UPDATE_CUSTOMERS_ERRORS };
